module.exports = __webpack_public_path__ + "img/jjbg.0f61ff8f.jpeg";